/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.getSuggestionsSkeleton'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  viewer: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  relativeToDid: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  actors: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<UnspeccedDefs.SkeletonSearchActor>(
      (() => UnspeccedDefs.skeletonSearchActor) as any,
    ),
  ),
  relativeToDid: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
  recId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a skeleton of suggested actors. Intended to be called and then hydrated through app.bsky.actor.getSuggestions */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
